import React, { Fragment, useRef, useState } from "react";
import styled from "styled-components";
import Accordion from "../components/Accordion";
import useCheckIsMobile from "../hooks/useCheckIsMobile";

const FooterWrapper = styled.footer`
  background-color: #212121;
  padding: 80px 40px;
  box-sizing: border-box;
  margin-top: auto;
  @media (max-width: 425px) {
    padding: 40px 40px;
    text-align: center;
  }
  @media (max-width: 768px) {
    text-align: left;
  }
`;

const FooterContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 250px;
  @media (max-width: 840px) {
    min-width: 215px;
  }
  @media (max-width: 425px) {
    min-width: 100%;
  }
`;

const FooterWrapperContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin: 40px 0px 25px 0px;
  flex-wrap: wrap;
  @media (max-width: 425px) {
    justify-content: flex-start;
    margin: 0px;
  }
`;

const CenterContainer = styled.div`
  display: flex;
  justify-content: center;
  @media (max-width: 425px) {
    margin-top: 40px;
  }
`;

const FooterContentTitle = styled.h2`
  color: #f86a6e;
  font-family: "Lato";
  font-size: 20px;
  margin: 0;
  margin-bottom: 25px;
  @media (max-width: 425px) {
    margin: 10px 0px;
  }
`;

const FooterContent = styled.p`
  font-family: "Lato";
  font-size: 15px;
  color: #afafaf;
  margin: 10px 0px;
`;

const FooterPicMakerTitle = styled.h2`
  color: #fff;
  font-family: "Lato";
  font-size: 24px;
  margin: 0px;
  margin-bottom: 30px;
  @media (max-width: 425px) {
    margin: 30px 0px;
  }
`;

const FooterMakerTitle = styled.h2`
  font-family: "Lato";
  font-size: 18px;
  font-weight: bold;
  color: #afafaf;
  margin: 0;
  span {
    color: #f1821e;
  }
`;

const FooterLink = styled.a`
  text-decoration: none;
  color: #afafaf;
  transition: all 0.3s linear;
  -webkit-transition: all 0.3s linear;
  margin: 10px 0px;
  &:hover {
    color: #fff;
    padding-left: 10px;
  }
`;

const FooterSocialLink = styled(FooterLink)`
  &:hover {
    padding-left: 0px;
    color: #fff;
  }
`;

const FooterAddressContainer = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 0.5;
  margin: 10px 0px;
  span {
    margin: 10px 0px;
    img {
      margin-right: 20px;
    }
  }
`;

const FooterMotoContent = styled.h2`
  font-family: "Lato";
  color: #fff;
  font-size: 40px;
  font-weight: bold;
  margin: 20px 0px 0px;
  span {
    color: #f1821e;
  }
  @media (max-width: 425px) {
    text-align: center;
  }
`;

const FooterCopyRightContent = styled(FooterContent)`
  text-align: center;
  span {
    color: #f76b6b;
  }
`;

const BASE_PATH = process.env.BASE_PATH;
const LinkUrl = "https://www.picmaker.com";

const accordionData = [
  {
    title: "For social media",
    content: [
      {
        title: "Youtube Banner Maker",
        link: `${LinkUrl}/youtube-banner-maker`,
      },
      {
        title: "Youtube Thumbnail Maker",
        link: `${LinkUrl}/youtube-thumbnail-maker`,
      },
      {
        title: "Facebook Ad Creator",
        link: `${LinkUrl}/facebook-ad-creator`,
      },
      {
        title: "Facebook Post Maker",
        link: `${LinkUrl}/facebook-post-maker`,
      },
      {
        title: "Instagram Story Maker",
        link: `${LinkUrl}/instagram-story-maker`,
      },
      {
        title: "Instagram Post Maker",
        link: `${LinkUrl}/instagram-post-maker`,
      },
      {
        title: "Twitter Post Maker",
        link: `${LinkUrl}/twitter-post-maker`,
      },
      {
        title: "LinkedIn Banner Maker",
        link: `${LinkUrl}/linkedin-banner-maker`,
      },
      {
        title: "GIF maker",
        link: `https://www.gifmaker.com`,
      },
    ],
  },
  {
    title: "For business",
    content: [
      {
        title: "Email Header",
        link: `${LinkUrl}/email-header`,
      },
      {
        title: "Invitation Maker",
        link: `${LinkUrl}/invitation-maker`,
      },
      {
        title: "Blog Banner Maker",
        link: `${LinkUrl}/free-blog-banner-maker`,
      },
      {
        title: "Blog Graphics",
        link: `${LinkUrl}/free-blog-graphics`,
      },
      {
        title: "Poster Maker",
        link: `${LinkUrl}/poster-maker`,
      },
      {
        title: "Invoice Maker",
        link: `${LinkUrl}/invoice-maker`,
      },
      {
        title: "Label Maker",
        link: `${LinkUrl}/label-maker`,
      },
      {
        title: "Flyer Maker",
        link: `${LinkUrl}/flyer-maker`,
      },
      {
        title: "Logo Maker",
        link: `${LinkUrl}/logo-maker`,
      },
    ],
  },
  {
    title: "For everything else",
    content: [
      {
        title: "Book Cover Maker",
        link: `${LinkUrl}/book-cover-maker`,
      },
      {
        title: "Certificate Maker",
        link: `${LinkUrl}/certificate-maker`,
      },
      {
        title: "Brochure Maker",
        link: `${LinkUrl}/brochure-maker`,
      },
      {
        title: "Stock Images",
        link: `${LinkUrl}/features/stock-images`,
      },
      {
        title: "Sticker Maker",
        link: `${LinkUrl}/sticker-maker`,
      },
      {
        title: "Meme Generator",
        link: `${LinkUrl}/meme-generator`,
      },
      {
        title: "Photo Editor",
        link: `${LinkUrl}/photo-editor`,
      },
      {
        title: "Collage Maker",
        link: `${LinkUrl}/collage-maker`,
      },
      {
        title: "Background Remover",
        link: `${LinkUrl}/background-remover`,
      },
      {
        title: "Canva Alternatives",
        link: `${LinkUrl}/canva-alternatives`,
      },
    ],
  },
  {
    title: "Learn",
    content: [
      { title: "Blog", link: `${LinkUrl}/blog/` },
      { title: "Tutorials", link: `${LinkUrl}/tutorials/` },
      { title: "Webinar", link: `${LinkUrl}/webinar/` },
      // { title: "FAQ", link: `https://support.picmaker.com/en/` },
      { title: "Brand Assets", link: `${LinkUrl}/brand-assets` },
    ],
  },
  {
    title: "Company",
    content: [
      { title: "About us", link: `${LinkUrl}/about` },
      { title: "Contact", link: `https://app.picmaker.com/support/` },
      { title: "Feedback", link: `https://app.picmaker.com/feedback/` },
      { title: "Privacy", link: `${LinkUrl}/privacy` },
    ],
  },
];

export default function Footer() {
  const { isMobileWidth } = useCheckIsMobile();
  const [currentAccordion, setCurrentAccordion] = useState(null);
  const [bodyHeight, setBodyHeight] = useState(0);

  const socialRef = useRef(null);
  const businessRef = useRef(null);
  const everythingRef = useRef(null);
  const companyRef = useRef(null);
  const supportRef = useRef(null);

  const refs = [socialRef, businessRef, everythingRef, companyRef, supportRef];
  return (
    <FooterWrapper>
      {isMobileWidth && (
        <Accordion
          accordionContent={accordionData}
          refs={refs}
          currentAccordion={currentAccordion}
          setCurrentAccordion={setCurrentAccordion}
          setBodyHeight={setBodyHeight}
          bodyHeight={bodyHeight}
        />
      )}
      {!isMobileWidth && (
        <Fragment>
          <FooterWrapperContainer>
            <FooterContentWrapper>
              <FooterContentTitle>For social media</FooterContentTitle>
              <FooterLink
                href={`${LinkUrl}/youtube-banner-maker`}
                rel="noopener"
              >
                Youtube Banner Maker
              </FooterLink>
              <FooterLink
                href={`${LinkUrl}/youtube-thumbnail-maker`}
                rel="noopener"
              >
                Youtube Thumbnail Maker
              </FooterLink>
              <FooterLink
                href={`${LinkUrl}/facebook-ad-creator`}
                rel="noopener"
              >
                Facebook Ad Creator
              </FooterLink>
              <FooterLink
                href={`${LinkUrl}/facebook-post-maker`}
                rel="noopener"
              >
                Facebook Post Maker
              </FooterLink>
              <FooterLink
                href={`${LinkUrl}/instagram-story-maker`}
                rel="noopener"
              >
                Instagram Story Maker
              </FooterLink>
              <FooterLink
                href={`${LinkUrl}/instagram-post-maker`}
                rel="noopener"
              >
                Instagram Post Maker
              </FooterLink>
              <FooterLink href={`${LinkUrl}/twitter-post-maker`} rel="noopener">
                Twitter Post Maker
              </FooterLink>
              <FooterLink
                href={`${LinkUrl}/linkedin-banner-maker`}
                rel="noopener"
              >
                Linkedin Banner Maker
              </FooterLink>
              <FooterLink href={`https://www.gifmaker.com`} rel="noopener">
                GIF maker
              </FooterLink>
            </FooterContentWrapper>
            <FooterContentWrapper>
              <FooterContentTitle>For business</FooterContentTitle>
              <FooterLink href={`${LinkUrl}/email-header`} rel="noopener">
                Email Header
              </FooterLink>
              <FooterLink href={`${LinkUrl}/invitation-maker`} rel="noopener">
                Invitation Maker
              </FooterLink>
              <FooterLink
                href={`${LinkUrl}/free-blog-banner-maker`}
                rel="noopener"
              >
                Blog Banner Maker
              </FooterLink>
              <FooterLink href={`${LinkUrl}/free-blog-graphics`} rel="noopener">
                Blog Graphics
              </FooterLink>
              <FooterLink href={`${LinkUrl}/poster-maker`} rel="noopener">
                Poster Maker
              </FooterLink>
              <FooterLink href={`${LinkUrl}/invoice-maker`} rel="noopener">
                Invoice Maker
              </FooterLink>
              <FooterLink href={`${LinkUrl}/label-maker`} rel="noopener">
                Label Maker
              </FooterLink>
              <FooterLink href={`${LinkUrl}/flyer-maker`} rel="noopener">
                Flyer Maker
              </FooterLink>
              <FooterLink href={`${LinkUrl}/logo-maker`} rel="noopener">
                Logo Maker
              </FooterLink>
            </FooterContentWrapper>
            <FooterContentWrapper>
              <FooterContentTitle>For everything else</FooterContentTitle>
              <FooterLink href={`${LinkUrl}/book-cover-maker`} rel="noopener">
                Book Cover Maker
              </FooterLink>
              <FooterLink href={`${LinkUrl}/certificate-maker`} rel="noopener">
                Certificate Maker
              </FooterLink>
              <FooterLink href={`${LinkUrl}/brochure-maker`} rel="noopener">
                Brochure Maker
              </FooterLink>
              <FooterLink
                href={`${LinkUrl}/features/stock-images`}
                rel="noopener"
              >
                Stock Images
              </FooterLink>
              <FooterLink href={`${LinkUrl}/sticker-maker`} rel="noopener">
                Sticker Maker
              </FooterLink>
              <FooterLink href={`${LinkUrl}/meme-generator`} rel="noopener">
                Meme Generator
              </FooterLink>
              <FooterLink href={`${LinkUrl}/photo-editor`} rel="noopener">
                Photo Editor
              </FooterLink>
              <FooterLink href={`${LinkUrl}/collage-maker`} rel="noopener">
                Collage Maker
              </FooterLink>
              <FooterLink href={`${LinkUrl}/background-remover`} rel="noopener">
                Background Remover
              </FooterLink>
              <FooterLink href={`${LinkUrl}/canva-alternatives`} rel="noopener">
                Canva Alternatives
              </FooterLink>
            </FooterContentWrapper>
          </FooterWrapperContainer>
        </Fragment>
      )}
      <FooterWrapperContainer>
        {!isMobileWidth && (
          <Fragment>
            <FooterContentWrapper>
              <FooterContentTitle>Learn</FooterContentTitle>
              <FooterLink href={`${LinkUrl}/blog/`}>Blog</FooterLink>
              <FooterLink href={`${LinkUrl}/tutorials/`}>Tutorials</FooterLink>
              <FooterLink href={`${LinkUrl}/webinar/`}>Webinar</FooterLink>
              {/* <FooterLink href={"https://support.picmaker.com/en/"}>
                FAQ
              </FooterLink> */}
              <FooterLink href={`${LinkUrl}/brand-assets`}>
                Brand Assets
              </FooterLink>
            </FooterContentWrapper>
            <FooterContentWrapper>
              <FooterContentTitle>Company</FooterContentTitle>
              <FooterLink href={`${LinkUrl}/about`}>About us</FooterLink>
              <FooterLink href={"https://app.picmaker.com/support/"}>
                Contact
              </FooterLink>
              <FooterLink href={"https://app.picmaker.com/feedback/"}>
                Feedback
              </FooterLink>
              <FooterLink href={`${LinkUrl}/privacy`}>Privacy</FooterLink>
            </FooterContentWrapper>
          </Fragment>
        )}
        <FooterContentWrapper>
          <FooterPicMakerTitle>Picmaker</FooterPicMakerTitle>
          <FooterMakerTitle>
            From the makers of <span>Animaker!</span>
          </FooterMakerTitle>
          <FooterContent>The future of photo making starts here!</FooterContent>
          <FooterAddressContainer>
            <FooterContent>3260 Hillview Avenue,</FooterContent>
            <FooterContent>Palo Alto, CA 94304, USA.</FooterContent>
            <FooterSocialLink href={`mailto:yo@picmaker.com`} rel="noopener">
              yo@picmaker.com
            </FooterSocialLink>
            <span>
              <FooterSocialLink
                href="https://www.facebook.com/thepicmaker"
                target="_blank"
                rel="noopener"
              >
                <img
                  src={`${BASE_PATH}/images/icon-facebook.svg`}
                  alt="facebook-icon"
                  width="13px"
                  height="13px"
                  title="facebook-icon"
                />
              </FooterSocialLink>
              <FooterSocialLink
                href="https://www.instagram.com/picmakerhq"
                target="_blank"
                rel="noopener"
              >
                <img
                  src={`${BASE_PATH}/images/icon-instagram.svg`}
                  alt="instagram-icon"
                  width="13px"
                  height="13px"
                  title="instagram-icon"
                />
              </FooterSocialLink>
              <FooterSocialLink
                href="https://twitter.com/PicmakerHQ"
                target="_blank"
                rel="noopener"
              >
                <img
                  src={`${BASE_PATH}/images/icon-twitter.svg`}
                  alt="twitter-icon"
                  width="13px"
                  height="13px"
                  title="twitter-icon"
                />
              </FooterSocialLink>
              <FooterSocialLink
                href="https://www.linkedin.com/showcase/picmaker/"
                target="_blank"
                rel="noopener"
              >
                <img
                  src={`${BASE_PATH}/images/icon-linkedin.svg`}
                  alt="linkedin-icon"
                  width="13px"
                  height="13px"
                  title="linkedin-icon"
                />
              </FooterSocialLink>
              <FooterSocialLink
                href="https://www.youtube.com/channel/UClpbRJ0wLPUvFrDR_oBnbcg"
                target="_blank"
                rel="noopener"
              >
                <img
                  src={`${BASE_PATH}/images/icon-youtube.svg`}
                  alt="youtube-icon"
                  width="13px"
                  height="13px"
                  title="youtube-icon"
                />
              </FooterSocialLink>
            </span>
          </FooterAddressContainer>
        </FooterContentWrapper>
      </FooterWrapperContainer>
      <FooterWrapperContainer>
        <FooterContentWrapper>
          <CenterContainer>
            <img
              src={`${BASE_PATH}/images/Footer-Logo.svg`}
              alt="footer-logo"
              width="85px"
              height="85px"
              title="footer-logo"
            />
          </CenterContainer>
          <FooterMotoContent>Designing the future</FooterMotoContent>
          <FooterCopyRightContent>
            Copyright © 2022 <span>Animaker Inc</span>, All rights reserved
          </FooterCopyRightContent>
        </FooterContentWrapper>
      </FooterWrapperContainer>
    </FooterWrapper>
  );
}
